module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.fe7ae63.woff";